import { protectedApi } from "./protectedApi";
import { APIS } from "../constants/apiConstant";

export async function fetchBirthdaySentToday() {
  const response = await protectedApi({ url: APIS.BIRTHDAY_SENT_TODAY, method: "GET" });
  const userIds = response?.data?.data?.userIds;
  return Array.isArray(userIds) ? userIds.map((id) => Number(id)).filter((id) => id > 0) : [];
}

export async function sendBirthdayEmail(userId) {
  const url = APIS.BIRTHDAY_SEND_EMAIL.replace(":userId", String(userId));
  const response = await protectedApi({ url, method: "POST" });
  return response?.data;
}
